






































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class TruncateTooltip extends Vue {
    public disabled = true;

    // Properties
    @Prop({required: true})
    public label!: string;

    @Prop({ required: false, default: true, type: Boolean })
    public top!: boolean;
    
    @Prop({ required: false, default: false, type: Boolean })
    public bottom!: boolean;
    
    @Prop({ required: false, default: false, type: Boolean })
    public left!: boolean;
    
    @Prop({ required: false, default: false, type: Boolean })
    public right!: boolean;

    public mounted() {
        // Check overflow on mount in case content is already truncated
        this.$nextTick(() => {
            this.checkOverflow();
        });
    }

    // Event Handler:
    public checkOverflow() {
        const container = this.$refs.container as HTMLElement;
        if (!container) {
            this.disabled = true;
            return;
        }

        // Check if any child element is overflowing
        let isOverflowing = false;
        
        // First check the container itself
        if (container.scrollWidth > container.offsetWidth || container.scrollHeight > container.offsetHeight) {
            isOverflowing = true;
        }
        
        // Then check direct children
        if (!isOverflowing) {
            const children = container.children;
            for (let i = 0; i < children.length; i++) {
                const child = children[i] as HTMLElement;
                if (child.scrollWidth > child.offsetWidth || child.scrollHeight > child.offsetHeight) {
                    isOverflowing = true;
                    break;
                }
            }
        }
        
        // Also check text nodes by comparing with a temporary element
        if (!isOverflowing && container.textContent) {
            const tempElement = document.createElement('span');
            tempElement.style.visibility = 'hidden';
            tempElement.style.position = 'absolute';
            tempElement.style.whiteSpace = 'nowrap';
            tempElement.textContent = container.textContent.trim();
            tempElement.style.font = window.getComputedStyle(container).font;
            
            document.body.appendChild(tempElement);
            const fullWidth = tempElement.offsetWidth;
            document.body.removeChild(tempElement);
            
            if (fullWidth > container.offsetWidth) {
                isOverflowing = true;
            }
        }

        this.disabled = !isOverflowing;
    }
}
